import script from "./FormFieldText.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldText.vue?vue&type=script&setup=true&lang=js"

import "./FormFieldText.vue?vue&type=style&index=0&id=4836d620&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4836d620"]])

export default __exports__